import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { QuoteSummaryModel } from '@amfam/shared/models';

@Component({
  selector: 'ds-wrap-section',
  templateUrl: './wrap-section.component.html',
  styleUrls: ['./wrap-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class WrapSectionComponent {
  @Input() itemList: QuoteSummaryModel[];
  @Input() headerContentRef: {
    path: string;
    options?: { [key: string]: string };
  };
  @Input() iconClass: string;
}
